(function () {
  'use strict';

  // Exit early if the browser lacks IntersectionObserver or user prefers reduced motion
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Elements inside these containers are excluded from animation
  var EXCLUDED = '.header, .header-drawer, [data-predictive-search], .product-card, .collection-card, [data-custom-animate-item]';

  // ── Hero entrance animation (runs once on page load) ─────────────────────
  function animateHero() {
    var mediaGrid = document.querySelector('.hero__media-grid');
    if (!mediaGrid || mediaGrid.dataset.heroAnimated) return;
    mediaGrid.dataset.heroAnimated = '1';
    mediaGrid.classList.add('hero-media--enter');
    // Double rAF ensures the browser has painted the initial state before transitioning
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        mediaGrid.classList.add('hero-media--visible');
      });
    });
  }

  /**
   * Marks elements with data attributes, then either shows them immediately
   * (if already in viewport) or hides + observes them for scroll-reveal.
   */
  function setupScrollAnimations() {
    var grids = [];
    var fadeItems = [];

    // ── Product grid (collection pages) ──────────────────────────────────────
    document.querySelectorAll('.product-grid:not([data-custom-animate])').forEach(function (grid) {
      var items = grid.querySelectorAll('.product-grid__item');
      if (!items.length) return;
      grid.setAttribute('data-custom-animate', 'stagger');
      items.forEach(function (item) { item.setAttribute('data-custom-animate-item', ''); });
      grids.push(grid);
    });

    // ── Resource-list grids (featured collections, recommendations) ───────────
    document.querySelectorAll('.resource-list--grid:not([data-custom-animate])').forEach(function (list) {
      if (list.closest(EXCLUDED)) return;
      var items = list.querySelectorAll('.resource-list__item');
      if (!items.length) return;
      list.setAttribute('data-custom-animate', 'stagger');
      items.forEach(function (item) { item.setAttribute('data-custom-animate-item', ''); });
      grids.push(list);
    });

    // ── Magnet toggle cards (homepage product grid) ───────────────────────────
    document.querySelectorAll('.mtc__grid:not([data-custom-animate])').forEach(function (grid) {
      var cards = grid.querySelectorAll('.mtc__card');
      if (!cards.length) return;
      grid.setAttribute('data-custom-animate', 'stagger');
      cards.forEach(function (card) { card.setAttribute('data-custom-animate-item', ''); });
      grids.push(grid);
    });

    // ── Text blocks (headings + body copy in all sections) ────────────────────
    document.querySelectorAll('.text-block:not([data-custom-animate])').forEach(function (el) {
      if (el.closest(EXCLUDED)) return;
      el.setAttribute('data-custom-animate', 'fade-up');
      fadeItems.push(el);
    });

    // ── Video blocks ──────────────────────────────────────────────────────────
    document.querySelectorAll('deferred-media:not([data-custom-animate])').forEach(function (el) {
      if (el.closest(EXCLUDED)) return;
      el.setAttribute('data-custom-animate', 'fade-up');
      fadeItems.push(el);
    });

    // ── Section-level: every shopify section scrolls in as a unit ────────────
    document.querySelectorAll('.shopify-section:not([data-custom-animate])').forEach(function (el) {
      if (el.closest('.header, .footer, [id*="header"], [id*="footer"]')) return;
      if (el.querySelector('[data-custom-animate]')) return; // already has child animations
      el.setAttribute('data-custom-animate', 'section');
      fadeItems.push(el);
    });

    // ── Standalone images inside sections (not in product/collection cards) ───
    document.querySelectorAll('.media:not([data-custom-animate]):not(.card-gallery *)').forEach(function (el) {
      if (el.closest(EXCLUDED)) return;
      el.setAttribute('data-custom-animate', 'fade-up');
      fadeItems.push(el);
    });

    // ── Custom section feature elements ───────────────────────────────────────
    var featureSelectors = [
      '.cat__featured:not([data-custom-animate])',
      '.cat__card:not([data-custom-animate])',
      '.ch__card:not([data-custom-animate])',
      '.mtc__hero-info:not([data-custom-animate])',
      '.cz__studio:not([data-custom-animate])',
      '.czt__studio:not([data-custom-animate])'
    ];
    document.querySelectorAll(featureSelectors.join(',')).forEach(function (el) {
      if (el.closest(EXCLUDED)) return;
      el.setAttribute('data-custom-animate', 'fade-up');
      fadeItems.push(el);
    });

    // ── Catalog cards (stagger) ───────────────────────────────────────────────
    document.querySelectorAll('.cat__cards:not([data-custom-animate])').forEach(function (grid) {
      var cards = grid.querySelectorAll('.cat__card');
      if (!cards.length) return;
      grid.setAttribute('data-custom-animate', 'stagger');
      cards.forEach(function (c) { c.setAttribute('data-custom-animate-item', ''); });
      grids.push(grid);
    });

    // ── Contact hero cards (stagger) ─────────────────────────────────────────
    document.querySelectorAll('.ch__cards:not([data-custom-animate])').forEach(function (grid) {
      var cards = grid.querySelectorAll('.ch__card');
      if (!cards.length) return;
      grid.setAttribute('data-custom-animate', 'stagger');
      cards.forEach(function (c) { c.setAttribute('data-custom-animate-item', ''); });
      grids.push(grid);
    });

    // ── Grid observer — stagger handled by CSS nth-child delays ──────────────
    if (grids.length) {
      var gridObserver = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -40px 0px', threshold: 0.05 });

      grids.forEach(function (grid) {
        var rect = grid.getBoundingClientRect();
        var alreadyVisible = rect.top < window.innerHeight && rect.bottom > 0;
        if (alreadyVisible) {
          grid.classList.add('is-visible');
        } else {
          grid.classList.add('will-animate');
          gridObserver.observe(grid);
        }
      });
    }

    // ── Fade-up observer — batch + sort so higher elements animate first ──────
    if (fadeItems.length) {
      var fadeObserver = new IntersectionObserver(function (entries, obs) {
        var visible = [];
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            visible.push(entry);
            obs.unobserve(entry.target);
          }
        });
        if (!visible.length) return;

        // Sort top-to-bottom so the reading cascade feels natural
        visible.sort(function (a, b) {
          return a.boundingClientRect.top - b.boundingClientRect.top;
        });

        // Stagger: 60 ms per step, capped at 5 steps so it doesn't drag
        visible.forEach(function (entry, i) {
          var delay = Math.min(i, 4) * 60;
          entry.target.style.transitionDelay = delay + 'ms';
          entry.target.classList.add('is-visible');
        });
      }, { rootMargin: '0px 0px -40px 0px', threshold: 0.08 });

      fadeItems.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        var alreadyVisible = rect.top < window.innerHeight && rect.bottom > 0;
        if (alreadyVisible) {
          el.classList.add('is-visible');
        } else {
          el.classList.add('will-animate');
          fadeObserver.observe(el);
        }
      });
    }
  }

  // Run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      animateHero();
      setupScrollAnimations();
    });
  } else {
    animateHero();
    setupScrollAnimations();
  }

  // Re-run when Shopify theme editor loads a new section dynamically
  document.addEventListener('shopify:section:load', setupScrollAnimations);
})();
